import "@/App.css";
import { Navigate } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { RouteSeo } from "@/components/RouteSeo";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import UeberUns from "@/pages/UeberUns";
import Portfolio from "@/pages/Portfolio";
import Verkaufen from "@/pages/Verkaufen";
import Partner from "@/pages/Partner";
import Referenzen from "@/pages/Referenzen";
import HaustuerKreuzbergstrasse from "@/pages/HaustuerKreuzbergstrasse";
import Kontakt from "@/pages/Kontakt";
import Bewerbung from "@/pages/Bewerbung";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

const TOASTER_OPTIONS = {
  style: {
    background: "hsl(40 20% 97%)",
    color: "hsl(210 10% 15%)",
    border: "1px solid hsl(40 15% 85%)",
    borderRadius: 0,
    fontFamily: "Manrope, sans-serif",
  },
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <RouteSeo />
      <Toaster
        position="bottom-right"
        toastOptions={TOASTER_OPTIONS}
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="ueber-uns" element={<UeberUns />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="verkaufen" element={<Verkaufen />} />
          <Route path="mietobjekte" element={<Navigate to="/referenzen" replace />} />
          <Route path="partner" element={<Partner />} />
          <Route path="bewerbung" element={<Bewerbung />} />
          <Route path="referenzen" element={<Referenzen />} />
          <Route path="referenzen/kreuzbergstrasse-haustuer" element={<HaustuerKreuzbergstrasse />} />
          <Route path="kontakt" element={<Kontakt />} />
          <Route path="impressum" element={<Impressum />} />
          <Route path="datenschutz" element={<Datenschutz />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
